<template>
  <div>
    <!-- LOGIN -->
    <section v-if="!needSignUp" class="hero is-primar is-fullheight">
      <div class="hero-body">
        <div class="container has-text-centered">
          <div class="column is-4 is-offset-4">
            <h3 class="title has-text-grey">Sign in</h3>
            <p class="subtitle has-text-grey">Please sign in to proceed.</p>
            <div class="box">
              <figure class="avatar column is-8 is-offset-2">
                <img src="src/assets/waiter.png">
              </figure>
              <form>
                <!-- errors -->
                <div class="has-text-left alert" v-if="errors.length">
                  <b>Please fix this errors:</b>
                   <ul>
                     <li v-for="(error,index) in errors"
                      :key="index">{{ error.description }}</li>
                   </ul>
                 </div>
                 <!-- end errors -->
                <button class="button is-block is-info is-large is-fullwidth" v-on:click.prevent="signin">Sign in</button>
              </form>
            </div>
            <p class="has-text-grey">

              <!-- <a href="../">Forgot Password</a> &nbsp;·&nbsp;
              <a href="../">Need Help?</a> -->
              This is private FastReports service and you should sign in to continue!
            </p>
          </div>
        </div>
      </div>
    </section>
        <!-- END LOGIN -->
  </div>
</template>

<script>
//import this.HTTP from "../Http";
import * as Oidc from "oidc-client";

console.log(process.env.BACKEND_URL == null);

export default {
  name: "auth-view",
  data() {
    return {
      needSignUp: false,
      username: "",
      email: "",
      password: "",
      errors: [],

    }
  },
  methods: {
    signin() {
      console.log(this.HTTP.signinRedirect);
      this.HTTP.signinRedirect()
      .catch(e => {

      });
    }
  },
  created() {
    this.HTTP.load();
    console.log(this.$route);

    // if (
    //   this.$route.query.id_token !== null &&
    //   this.$route.query.id_token !== undefined &&
    //   this.$route.query.id_token !== "undefined" &&
    //   this.$route.query.id_token.length > 0 &&
    //   this.$route.query.id_token.indexOf(".") !== -1
    // ) {
    //   this.$router.push("Changes");
    // }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/Auth.Vue